import { AnalyticsBrowser } from "@segment/analytics-next";
import { trackDirect } from "../mixpanel/mixpanelService";

const writeKey = process.env.REACT_APP_SEGMENT_WRITE_KEY;

const segment = AnalyticsBrowser.load({
  writeKey: writeKey || "",
});

/**
 * Every frontend event goes through here. During the Segment removal it sends
 * each event twice: to Segment, which still feeds the real Mixpanel project,
 * and to Mixpanel directly (see trackDirect).
 */
export const analytics = {
  track(event: string, properties?: Record<string, unknown>): void {
    try {
      segment.track(event, properties);
    } catch {
      // Analytics must never break the app; the direct copy still goes out.
    }
    trackDirect(event, properties);
  },
};
